import Vue from 'vue'
import App from '@/App.vue';

import router from '@/router'
import store from '@/store'

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { AuthWrapper } from "@/auth/AuthWrapper";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

import checkView from 'vue-check-view';
import { AppSettings as AppConfig } from './types';
Vue.use(checkView);

const authWrapper = new AuthWrapper();

Object.defineProperty(Vue.prototype, "$auth", {
    get: () => authWrapper
});

Vue.component('loading-spinner', LoadingSpinner);

async function loadConfig(): Promise<AppConfig> {
    const response: Response = await fetch('./config.json');
    const config: AppConfig = await response.json();

    return config;
}

loadConfig()
    .then((config: AppConfig) => {

        authWrapper.init(config);

        new Vue({
            router,
            store,
            render: h => h(App),
        }).$mount('#app');

    });